export default "/WebApp/dist/assets/svg/black-checkbox-checked.svg";